export var ChartPriceType = /*#__PURE__*/ function(ChartPriceType) {
    ChartPriceType["Price"] = "price";
    ChartPriceType["MarketCap"] = "marketCap";
    return ChartPriceType;
}({});
export const chartPriceTypeSelect = [
    "marketCap",
    "price"
];
